import { smsTemplateSchema } from "@redotech/redo-marketing-templates-common/sms-template";
import * as z from "zod";

export const getSmsTemplateById = {
  name: "getSmsTemplateById" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ template: smsTemplateSchema }),
};
